import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import {
  Grid,
  Input,
  MenuItem,
  FormControl,
  InputLabel,
  Select
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import InlineDatePicker from "../../utils/InlineDatePicker"
import MultiSelect from "../../utils/MultiSelectList";
import classNames from "classnames";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  root: {
    flexGrow: 1,
    paddingLeft: '15px'
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: '0 5px 0',
    minWidth: 120,
    width: '90%',
    display: "flex",
    wrap: "nowrap"
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: { marginTop: "0px", width: '100%' },
  multiSelect: {
    marginTop: "-5px"
  }
});

function SearchComponent(props) {
  let {
    classes, StartDate, EndDate,
    handleDateChange,
    onSearch,
    onValueChange,
    handleFilterModeChange,
    filterModes,
    selectedFilterMode,
    searchParams,
    searchPayload,
  } = props;

  return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item md={2}>
          <FormControl
            className={classes.formControl}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Filter Mode
                  </InputLabel>
            <Select
              value={selectedFilterMode}
              onChange={handleFilterModeChange}
              input={<Input name="airline" id="airline-label-placeholder" />}
              // displayEmpty
              name="selectedFilterMode"
              className={classes.selectEmpty}
            >
              <MenuItem value="-1">Select mode</MenuItem>
              {filterModes.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.Id}
                  className={classes.select}
                >
                  {option.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={4}>
          <FormControl
            className={classNames(classes.formControl, classes.multiSelect)}
          >
            <MultiSelect
              data={searchPayload}
              selectValue={searchParams}
              onValueChange={(e) => onValueChange(e)}
              valueKey={"Id"}
              textField={"Name"}
              label={'Search'}
            />
          </FormControl>
        </Grid>
        <Grid item md={2}>
          <div className={classes.formControl}>
            <InlineDatePicker label={'Start Date'} Date={StartDate} handleDateChange={(date) => handleDateChange(date, 'StartDate')} />
          </div>
        </Grid>
        <Grid item md={2}>
          <div className={classes.formControl}>
            <InlineDatePicker label={'End Date'} Date={EndDate} handleDateChange={(date) => handleDateChange(date, 'EndDate')} />
          </div>
        </Grid>

        <Grid item md={2}>
          <Button className={classes.searchButton} onClick={(() => onSearch())}>Search</Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(SearchComponent);



// WEBPACK FOOTER //
// ./src/views/AuditTrail/SearchPanel.jsx